import { render } from "./Configurazione.vue?vue&type=template&id=2fd3fbdf"
import script from "./Configurazione.vue?vue&type=script&lang=js"
export * from "./Configurazione.vue?vue&type=script&lang=js"
script.render = render

export default script